export default "__VITE_ASSET__Ddpfru9V__"